import { z } from "zod";

export const notificationType = z.enum([
  "MENTION",
  "COMMENT",
  "MESSAGE",
  "VISIT_TIME_EXPIRED",
  "VISIT_TIME_DECLINED",
  "TASK",
  "TASK_ASSIGNED",
  "TASK_COMPLETED",
  "TASK_UPDATED",
  "SCHEDULE_EVENT_CREATED",
  "SCHEDULE_EVENT_UPDATED",
  "SCHEDULE_EVENT_DELETED",
  "SCHEDULE_EVENT_REMIND_BEFORE_15_MIN",
  "SERVICE_CREATED",
]);

export const notificationCountSchema = z.object({
  total: z.number().default(0),
});

export const getNotificationCountSchema = z.object({
  filters: z
    .object({
      unRead: z.number().optional(),
      types: z.union([notificationType, z.array(notificationType)]).optional(),
    })
    .optional()
    .default({}),
});
